// extracted by mini-css-extract-plugin
module.exports = {"content":"index_content__YkVZ0","leftCover":"index_leftCover__LrIx6","rightCover":"index_rightCover__B6Fnj"};